var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53057 0.0577545L0.439453 2.83721V13.9537H4.43837V16.0393H6.62161L8.80268 13.9537H12.0752L16.4395 9.78636V0.0577545H1.53057ZM2.98425 1.4466H14.9852V9.0901L12.439 11.5224H8.43945L6.259 13.6052V11.5224H2.98425V1.4466ZM6.98476 8.39616H8.43944V4.22754H6.98476V8.39616ZM10.9846 8.39616H12.439V4.22754H10.9846V8.39616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.ac44d068.svg";
export { ForwardRef as ReactComponent };